import { Svg, type Props as SvgProps } from './Svg'

export const IconLink = (props: SvgProps) => (
	<Svg {...props} viewBox='0 0 24 24' fill='currentcolor' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M20.0079 3.00001C20.5569 2.998 21.002 3.44398 20.9999 3.99299V8.97297C20.9979 9.52302 20.53 9.97102 19.981 9.97297C19.4299 9.97499 18.9869 9.53102 18.988 8.97999L18.9899 6.42299L14.707 10.708C14.317 11.098 13.684 11.098 13.293 10.708C12.903 10.317 12.903 9.68397 13.293 9.29298L17.5759 5.00899L15.02 5.01198C14.4689 5.01399 14.0259 4.57002 14.028 4.01997C14.0289 3.46998 14.4769 3.00203 15.028 3.00001H20.0079ZM17 13C17 12.4477 17.4477 12 18 12C18.5523 12 19 12.4477 19 13V19C19 20.1046 18.1046 21 17 21H12H5C3.89543 21 3 20.1046 3 19V7.00001C3 5.89544 3.89543 5.00001 5 5.00001H11C11.5523 5.00001 12 5.44773 12 6.00001C12 6.5523 11.5523 7.00001 11 7.00001H5.5C5.22386 7.00001 5 7.22387 5 7.50001V18.5C5 18.7762 5.22386 19 5.5 19H12H16.5C16.7761 19 17 18.7762 17 18.5V13Z'
		/>
	</Svg>
)
